import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_59de254c from 'nuxt_plugin_plugin_59de254c' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_axios_ce0e6120 from 'nuxt_plugin_axios_ce0e6120' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginutils_c10f266a from 'nuxt_plugin_pluginutils_c10f266a' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_5910f356 from 'nuxt_plugin_pluginrouting_5910f356' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_1c7ea7d9 from 'nuxt_plugin_pluginmain_1c7ea7d9' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_templatesplugin562706c8_12dda282 from 'nuxt_plugin_templatesplugin562706c8_12dda282' // Source: ./templates.plugin.562706c8.js (mode: 'all')
import nuxt_plugin_image_f800672a from 'nuxt_plugin_image_f800672a' // Source: ./image.js (mode: 'all')
import nuxt_plugin_globals_64e2e0bc from 'nuxt_plugin_globals_64e2e0bc' // Source: ../../../plugins/globals (mode: 'all')
import nuxt_plugin_lazydatasources_0326042e from 'nuxt_plugin_lazydatasources_0326042e' // Source: ../../../plugins/lazy-datasources (mode: 'all')
import nuxt_plugin_touchevents_08b2ff5b from 'nuxt_plugin_touchevents_08b2ff5b' // Source: ../../../plugins/touch-events (mode: 'all')
import nuxt_plugin_flickity_7524e292 from 'nuxt_plugin_flickity_7524e292' // Source: ../../../plugins/flickity (mode: 'client')
import nuxt_plugin_route_231494d5 from 'nuxt_plugin_route_231494d5' // Source: ../../../plugins/route (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Geiger Gruppe","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"format-detection","content":"telephone=no"},{"name":"referrer","content":"strict-origin-when-cross-origin"},{"http-equiv":"Content-Security-Policy","content":"default-src 'self'; font-src 'self' *.b-ite.com; base-uri https:\u002F\u002Fwww.geigergruppe.com; media-src 'self' *.storyblok.com; connect-src *.geigergruppe.com *.google.com *.usercentrics.eu *.storyblok.com maps.googleapis.com *.b-ite.com *.google-analytics.com *.plyr.io *.doubleclick.net *.chatbase.co *.googleadservices.com *.ads.linkedin.com *.googlesyndication.com; frame-src *.vimeo.com *.geigergruppe.de *.doubleclick.net *.chatbase.co *.googletagmanager.com; img-src https: *.google-analytics.com *.storyblok.com localhost:3003 data:; style-src 'self' 'unsafe-inline' *.geigergruppe.com maps.googleapis.com *.b-ite.com; object-src blob:; worker-src blob:; script-src *.geigergruppe.com localhost:3003 *.usercentrics.eu maps.googleapis.com *.googletagmanager.com *.doubleclick.net *.vimeo.com *.facebook.com *.facebook.net 'unsafe-eval' 'unsafe-inline' *.google-analytics.com *.b-ite.com *.storyblok.com *.licdn.com *.chatbase.co *.googleadservices.com *.googlesyndication.com; "}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"preconnect","href":"https:\u002F\u002Fapi.storyblok.com"},{"rel":"preconnect","href":"https:\u002F\u002Fapp.usercentrics.eu"},{"rel":"preconnect","href":"https:\u002F\u002Fwww.googletagmanager.com"},{"rel":"preload","href":"https:\u002F\u002Fa.storyblok.com\u002Ff\u002F167299\u002Fx\u002F7e7932823d\u002Flogo-usercentrics.svg","as":"image"},{"rel":"preload","href":"\u002Ffonts\u002Fgeiger-build-full-bauhaus-bold.woff2","as":"font","type":"font\u002Fwoff2"},{"rel":"preload","href":"\u002Ffonts\u002Fgeiger-build-neutral-regular.woff2","as":"font","type":"font\u002Fwoff2"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_59de254c === 'function') {
    await nuxt_plugin_plugin_59de254c(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_ce0e6120 === 'function') {
    await nuxt_plugin_axios_ce0e6120(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_c10f266a === 'function') {
    await nuxt_plugin_pluginutils_c10f266a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_5910f356 === 'function') {
    await nuxt_plugin_pluginrouting_5910f356(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_1c7ea7d9 === 'function') {
    await nuxt_plugin_pluginmain_1c7ea7d9(app.context, inject)
  }

  if (typeof nuxt_plugin_templatesplugin562706c8_12dda282 === 'function') {
    await nuxt_plugin_templatesplugin562706c8_12dda282(app.context, inject)
  }

  if (typeof nuxt_plugin_image_f800672a === 'function') {
    await nuxt_plugin_image_f800672a(app.context, inject)
  }

  if (typeof nuxt_plugin_globals_64e2e0bc === 'function') {
    await nuxt_plugin_globals_64e2e0bc(app.context, inject)
  }

  if (typeof nuxt_plugin_lazydatasources_0326042e === 'function') {
    await nuxt_plugin_lazydatasources_0326042e(app.context, inject)
  }

  if (typeof nuxt_plugin_touchevents_08b2ff5b === 'function') {
    await nuxt_plugin_touchevents_08b2ff5b(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_flickity_7524e292 === 'function') {
    await nuxt_plugin_flickity_7524e292(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_route_231494d5 === 'function') {
    await nuxt_plugin_route_231494d5(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
